export default __webpack_public_path__ + "static/media/section2_bg.e086fcb0.png";